const styles = (theme) => ({
  marginTop: {
    marginTop: '24px',
  },
  filterButton: {
    marginTop: '16px',
  },
});

export default styles;
